import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithBody } from "@utils/http-util";
import { injectRpServiceIdAndChangeRequestStatus } from "@utils/parameter-injector";
import { RequestTypes } from "@enums/request-types";
import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { VerificationServiceChangeRequest } from "@idw-types/data/verification-service";

type UpdateVerificationServiceChangeRequestRequestResponse = {
    transferObject: VerificationServiceChangeRequest;
};

export const updateVerificationServiceChangeRequestRequest = async (
    rpServiceId: string,
    body: { [key: string]: any },
    changeRequestStatus: ChangeRequestStatusTypes
): Promise<{ data: UpdateVerificationServiceChangeRequestRequestResponse, error: any }> => {
    const route = injectRpServiceIdAndChangeRequestStatus(
        apiRoutes.serviceConfiguration.rpServiceConfig.changeRequest.rpService.updateChangeRequest,
        rpServiceId,
        changeRequestStatus
    );
    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error };
};